import React from 'react'
import PropTypes from 'prop-types'
import Row from '../../../../bootstrap/component/Row'
import Column from '../../../../bootstrap/component/Column'
import ContentBox from '../../../../layout/component/ContentBox'
import { formatDate } from '../../../../../util/datetime'
import { renderProcessName, renderStateName, renderTaskName } from '../../../../process/util/names'
import { Comment } from '../../../../process/component/instance-detail/CommentList'
import { CUSTOMER_COMMENT_LIST } from '../../../ui-definition/customer-ui'
import currentUserHasAccess from '../../../../../util/widget-helper'
import { lifecycle } from 'recompose'


const ProcessCommentList = ({ processCommentList }) => {
    if (processCommentList.length === 0) {
        return null
    }
    return (
        <tr>
            <td colSpan="5" style={{
                border: '1px solid #eee',
            }}>
                <div>
                    {processCommentList.map(comment => {
                        return (<Comment key={comment.id} comment={comment}/>)
                    })}
                </div>
            </td>
        </tr>
    )
}


const ProcessInstance = ({ processInstance }) => {
    return (
        <React.Fragment>
            <tr>
                <td>{renderProcessName(processInstance.processName)}</td>
                <td>{formatDate(processInstance.started)}</td>
                <td>{formatDate(processInstance.lastStatusChange)}</td>
                <td>{renderStateName(processInstance.currentStateName)}</td>
                <td>{renderTaskName(processInstance.currentTaskName)}</td>
            </tr>
            <ProcessCommentList processCommentList={processInstance.processCommentList}/>
        </React.Fragment>
    )
}


const ProcessInstanceList = ({ processInstanceList }) => {
    if (!currentUserHasAccess(CUSTOMER_COMMENT_LIST)) {
        return null
    }
    if (!processInstanceList || processInstanceList.length === 0) {
        return null
    }
    return (
        <ContentBox title="View Comments">
            <Row top="M">
                <Column size={12}>
                    <table className="default-table">
                        <thead>
                        <tr>
                            <th>Process</th>
                            <th>Started</th>
                            <th>Last Status Change</th>
                            <th>Current State</th>
                            <th>Current Task</th>
                        </tr>
                        </thead>
                        <tbody>
                        {processInstanceList.map(processInstance => {
                            return (
                                <ProcessInstance
                                    key={processInstance.id}
                                    processInstance={processInstance}
                                />)
                        })}
                        </tbody>
                    </table>
                </Column>
            </Row>
        </ContentBox>
    )
}

ProcessInstanceList.propTypes = {
    processInstanceList: PropTypes.array,
    findProcessCommentList: PropTypes.func.isRequired,
}

export default lifecycle({
    componentDidMount () {
        const { findProcessCommentList } = this.props
        findProcessCommentList()
    },
})(ProcessInstanceList)



// WEBPACK FOOTER //
// ./src/modules/customer/component/detail/tab-comments/ProcessCommentList.js